import { ReactNode, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppDispatch, RootState } from "../app/Store";
import { siteSelectionChanged } from "../app/store/GlobalActions";

export default function SiteSelectionBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const metadata = useSelector((state: RootState) => state.multiSitesMetadata);
  const selectedSiteId = useSelector((state: RootState) => state.site.siteId);
  let siteCode = "";
  try {
    siteCode = decodeURIComponent(pathname.split("/")[1] ?? "");
  } catch {
    // Invalid route encoding must not leave the previous site's controls active.
  }
  const siteId = metadata.siteCodeToIdMap[siteCode] ?? "";
  useLayoutEffect(() => {
    dispatch(siteSelectionChanged({ siteId }));
  }, [dispatch, metadata.sites, siteId]);

  return selectedSiteId === siteId ? <>{children}</> : null;
}
